import moment from "moment-timezone";
import { useTranslation } from "react-i18next";
import { dailyChart } from "../busy-times-utils";

const DailyVisitsChart = ({ busy, timeZone }) => {
  const { t } = useTranslation("coaching-portal");
  const chart = dailyChart(busy.dailyVisits, timeZone);
  const fmt = (day) => moment.utc(day, "YYYY-MM-DD").format("MMM D");
  const range = `${fmt(busy.effectiveFrom)} – ${fmt(busy.effectiveTo)}`;

  return (
    <div className="door-card door-daily">
      <div>
        <h3>{t("doorAccess.busy.daily.title")}</h3>
        <p className="door-muted">
          {t("doorAccess.busy.daily.subtitle", { range })}
        </p>
      </div>
      <svg
        viewBox={`0 0 ${chart.width} ${chart.height}`}
        role="img"
        aria-label={t("doorAccess.busy.daily.title")}
      >
        {chart.ticks.map((tick) => (
          <g key={tick.value} data-kind="tick">
            <line x1="34" x2={chart.width} y1={tick.y} y2={tick.y} />
            <text x="26" y={tick.y + 4} textAnchor="end">
              {tick.value}
            </text>
          </g>
        ))}
        {chart.bars.map((bar) => (
          <g key={bar.date}>
            <title>
              {t(
                bar.partial
                  ? "doorAccess.busy.daily.tipToday"
                  : "doorAccess.busy.daily.tip",
                { date: bar.title, count: bar.visits }
              )}
            </title>
            <rect
              x={bar.x}
              y={bar.y}
              width={bar.width}
              height={bar.height}
              rx="3"
              data-partial={bar.partial || undefined}
            />
            {bar.label && (
              <text x={bar.center} y={chart.height - 4} textAnchor="middle">
                {bar.label}
              </text>
            )}
          </g>
        ))}
        <line
          className="door-daily__average"
          x1="34"
          x2={chart.width}
          y1={chart.averageY}
          y2={chart.averageY}
        />
        <text
          className="door-daily__average-label"
          x={chart.width - 4}
          y={chart.averageY - 6}
          textAnchor="end"
        >
          {t("doorAccess.busy.daily.average", {
            count: Math.round(chart.average),
          })}
        </text>
      </svg>
    </div>
  );
};

export default DailyVisitsChart;
